<template>
    <div>
        <div class="card-header w-100 d-flex align-items-center">
            <h3 class="card-title">Plazas del recinto</h3>
            <div class="ml-auto">
                <Button class="mr-2" @click="volver()">Seleccionar otra región</Button>
                <Button @click.prevent="guardarPrecios()" :disabled="loadingButacas">Guardar todos</Button>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <ContentOrLoading>
                        <div v-if="plazas.length > 0">
                            <div v-for="(plaza, index) in originalPlazas" class="row mb-4" :key="index">
                                <div class="col-12 col-md-10">
                                    <div class="row">
                                        <div class="col-12 col-md-2 my-auto mb-2 mb-md-0">
                                            <span class="" v-if="plaza.butaca">
                                                <small>Sector: {{ plaza.sector_name }}</small><br/>
                                                <strong> Fila: {{ plaza.fila }} - Butaca: {{ plaza.butaca }}</strong>
                                            </span>
                                            <strong v-else>{{ plaza.name }}</strong>
                                        </div>
                                        <div class="col-12 col-md-5 mb-2 mb-md-0" :id="'taquilla-' + plaza.id">
                                            <label for="precio_taquilla" v-if="index === 0 && !esMovil || esMovil">Precio Taquilla:</label>
                                            <multiselect
                                                :data-cy="'preciosTaquillaButacas-' + index"
                                                v-model="plaza.precios_taquilla"
                                                placeholder="Precios taquilla"
                                                track-by="id"
                                                :custom-label="labelTaquilla"
                                                :options="entradas"
                                                :multiple="true"
                                                :max-height="150"
                                                @select="selected(plaza, 'taquilla')"
                                                @remove="selected(plaza, 'taquilla')"
                                            >
                                                <template slot="noOptions">No hay precios para taquilla creados</template>
                                            </multiselect>
                                        </div>
                                        <div class="col-12 col-md-5" :id="'online-' + plaza.id">
                                            <label for="precios_online" v-if="index === 0 && !esMovil || esMovil">Precios Online:</label>
                                            <multiselect
                                                :data-cy="'preciosOnlineButacas-' + index"
                                                v-model="plaza.precios_online"
                                                placeholder="Precios online"
                                                track-by="id"
                                                :custom-label="labelOnline"
                                                :options="entradas"
                                                :multiple="true"
                                                :max-height="150"
                                                @select="selected(plaza, 'online')"
                                                @remove="selected(plaza, 'online')"
                                            >
                                                <template slot="noOptions">No hay precios online creados</template>
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="index === 0 && !esMovil" class="col-12 col-md-2 text-right pt-4 mt-md-0">
                                    <Button 
                                        @click.prevent="guardarPrecios([plaza])" 
                                        :id="'btn-' + plaza.id"
                                        class="btn btn-block"
                                        :disabled="loadingButacas"
                                    >
                                        Guardar
                                    </Button>
                                </div>
                                <div v-if="!(index === 0) && !esMovil" class="col-12 col-md-2 text-right mt-md-0">
                                    <Button 
                                        @click.prevent="guardarPrecios([plaza])" 
                                        :id="'btn-' + plaza.id"
                                        class="btn btn-block"
                                        :disabled="loadingButacas"
                                    >
                                        Guardar
                                    </Button>
                                </div>
                                <div v-if="esMovil" class="col-12 col-md-2 text-right pt-4 mt-md-0">
                                    <Button 
                                        @click.prevent="guardarPrecios([plaza])" 
                                        :id="'btn-' + plaza.id"
                                        class="btn btn-block"
                                        :disabled="loadingButacas"
                                    >
                                        Guardar
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </ContentOrLoading>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        props: ['entradas', 'plazas', 'region', 'seleccionarTodas'],
        data() {
            return {
                originalPlazas: [],
                loadingButacas: false,
                esMovil: false,
                precioSeleccionado: []
            }
        },
        created() {
            this.esMovil = window.innerWidth <= 768;
            this.originalPlazas = this.plazas;
        },
        methods: {
            labelTaquilla({
                description,
                price,
                price_management_taquilla_interno,
                price_management_taquilla,
                descripcion,
                precio,
                dia_abonado,
                acompanante_abonado,
                amigo_abonado
            }) {
                description = description ?? descripcion;
                price = price ?? precio;
                var total = parseFloat(price) + price_management_taquilla;

                let abonadoLabel = '';
                if (dia_abonado) {
                    abonadoLabel = ' - Día de abonado';
                } else if (acompanante_abonado) {
                    abonadoLabel = ' - Acompañante de abonado';
                } else if (amigo_abonado) {
                    abonadoLabel = ' - Amigo de abonado';
                }

                if (price_management_taquilla_interno == 1) {
                    return (
                        description +
                        abonadoLabel +
                        ' - (' +
                        parseFloat(price).toFixed(2) +
                        '€' +
                        ')'
                    );
                } else {
                    return (
                        description +
                        abonadoLabel +
                        ' - (' +
                        parseFloat(total).toFixed(2) +
                        '€' +
                        ')'
                    );
                }
            },
            labelOnline({
                description,
                price,
                price_management_online_interno,
                price_management_online,
                descripcion,
                precio,
                dia_abonado,
                acompanante_abonado,
                amigo_abonado
            }) {
                description = description ?? descripcion;
                price = price ?? precio;
                var total = parseFloat(price) + price_management_online;

                let abonadoLabel = '';
                if (dia_abonado) {
                    abonadoLabel = ' - Día de abonado';
                } else if (acompanante_abonado) {
                    abonadoLabel = ' - Acompañante de abonado';
                } else if (amigo_abonado) {
                    abonadoLabel = ' - Amigo de abonado';
                }

                if (price_management_online_interno == 1) {
                    return (
                        description +
                        abonadoLabel +
                        ' - (' +
                        parseFloat(price).toFixed(2) +
                        '€' +
                        ')'
                    );
                } else {
                    return (
                        description +
                        abonadoLabel +
                        ' - (' +
                        parseFloat(total).toFixed(2) +
                        '€' +
                        ')'
                    );
                }
            },
            guardarPrecios(plazas) {
                const plazasAGuardar = plazas || this.originalPlazas;

                this.loadingButacas = true;

                const plazasCambiadas = plazasAGuardar.filter(plaza => plaza.changed);

                const formattedPlazas = plazasCambiadas.map(plaza => {
                    return {
                        id: plaza.id,
                        precios_taquilla: plaza.precios_taquilla.map(precio => precio.id),
                        precios_online: plaza.precios_online.map(precio => precio.id)
                    };
                });

                const params = {
                    filters: {}, 
                    data: formattedPlazas,
                    evento_id: this.$route.params.evento_id, 
                    sesion_id: this.$route.params.sesion_id 
                };

                if (this.region) {
                    params.filters.region_id = this.region.id;
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.butacas.guardar-precios'), params)
                    .then(() => {
                        this.$emit('recargar', null, 'porPlazas');
                        this.$emit('getButacas');
                        this.$toast.success('Precios guardados correctamente!');
                        this.loadingButacas = false;
                    }).catch(() => {
                        this.$toast.error('Ha ocurrido un error al guardar los precios');
                    });
            },
            selected(plazaSelected, tipo) {
                if (this.seleccionarTodas) {
                    this.preciosSeleccionados = tipo === 'taquilla' ? plazaSelected.precios_taquilla : plazaSelected.precios_online;
                    this.originalPlazas.forEach(plaza => {
                        plaza[tipo === 'taquilla' ? 'precios_taquilla' : 'precios_online'] = [...this.preciosSeleccionados];
                        plaza.changed = true;
                    });
                }
                let foundIndex = this.originalPlazas.findIndex(plaza => plaza.id === plazaSelected.id);
                if (foundIndex !== -1) {
                    this.originalPlazas[foundIndex].changed = true;
                }

                if (this.recargar) {
                    this.$emit('recargar');
                }
            },
            volver() {
                this.originalPlazas = null,
                this.$emit('volver');
            }
        }
    }
</script>